import { getOrgUnits, getUsers } from '@web/lib/demo/utils';
import { GeminiGroupedChartViewEnum, GeminiUsageLevelEnum } from '@workalizer/shared/enums';
import { GEMINI_USAGE_LEVELS, getGeminiUsageLevelDistributionWeekPeriods } from '@workalizer/shared/lib/gemini-usage-level';
import { getPercentageDiff } from '@workalizer/shared/utils';
import { format } from 'date-fns';
var LEVEL_CYCLE = [
    GeminiUsageLevelEnum.ZERO,
    GeminiUsageLevelEnum.LOW,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.HIGH
];
var buildLevelCounts = function (usersInScope, levelOffset) {
    return GEMINI_USAGE_LEVELS.reduce(function (acc, level, index) {
        acc[level] = Math.max(1, Math.floor(usersInScope / 4) + ((index + levelOffset) % 3));
        return acc;
    }, {});
};
var TEAM_USER_COUNT = 8;
export var geminiUsageLevelDistribution = function (input) {
    var dateFrom = format(new Date(input.dateFrom), 'yyyy-MM-dd');
    var dateTo = format(new Date(input.dateTo), 'yyyy-MM-dd');
    var users = getUsers({
        userId: input.userId,
        orgUnitId: input.orgUnitId
    });
    var usersInScope = users.length || 204;
    if (input.userId) {
        var weekPeriods = getGeminiUsageLevelDistributionWeekPeriods(dateFrom, dateTo);
        var summaryCounts_1 = buildLevelCounts(1, 1);
        var summary = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
            var teamCount = Math.max(1, Math.floor(TEAM_USER_COUNT / 4) +
                (level === GeminiUsageLevelEnum.MEDIUM ? 2 : 0));
            acc[level] = {
                count: summaryCounts_1[level],
                share: level === GeminiUsageLevelEnum.MEDIUM ? 100 : 0,
                previous: getPercentageDiff(1, summaryCounts_1[level]),
                teamAverage: getPercentageDiff(teamCount, summaryCounts_1[level])
            };
            return acc;
        }, {});
        return {
            period: {
                isValid: true,
                weekCount: weekPeriods.length,
                effectiveDateFrom: dateFrom,
                effectiveDateTo: dateTo
            },
            usersInScope: 1,
            summary: summary,
            view: GeminiGroupedChartViewEnum.PERIOD,
            segments: weekPeriods.map(function (week, index) {
                var _a, _b;
                var _c;
                var currentLevel = LEVEL_CYCLE[index % LEVEL_CYCLE.length];
                var previousLevel = (_c = LEVEL_CYCLE[(index + 1) % LEVEL_CYCLE.length]) !== null && _c !== void 0 ? _c : GeminiUsageLevelEnum.ZERO;
                var teamLevels = buildLevelCounts(TEAM_USER_COUNT, index + 2);
                return {
                    id: week.period,
                    name: week.period,
                    period: week.period,
                    dateFrom: week.dateFrom,
                    dateTo: week.dateTo,
                    previousPeriodLabel: week.period,
                    currentLevels: (_a = {},
                        _a[GeminiUsageLevelEnum.ZERO] = currentLevel === GeminiUsageLevelEnum.ZERO ? 1 : 0,
                        _a[GeminiUsageLevelEnum.LOW] = currentLevel === GeminiUsageLevelEnum.LOW ? 1 : 0,
                        _a[GeminiUsageLevelEnum.MEDIUM] = currentLevel === GeminiUsageLevelEnum.MEDIUM ? 1 : 0,
                        _a[GeminiUsageLevelEnum.HIGH] = currentLevel === GeminiUsageLevelEnum.HIGH ? 1 : 0,
                        _a),
                    previousLevels: (_b = {},
                        _b[GeminiUsageLevelEnum.ZERO] = previousLevel === GeminiUsageLevelEnum.ZERO ? 1 : 0,
                        _b[GeminiUsageLevelEnum.LOW] = previousLevel === GeminiUsageLevelEnum.LOW ? 1 : 0,
                        _b[GeminiUsageLevelEnum.MEDIUM] = previousLevel === GeminiUsageLevelEnum.MEDIUM ? 1 : 0,
                        _b[GeminiUsageLevelEnum.HIGH] = previousLevel === GeminiUsageLevelEnum.HIGH ? 1 : 0,
                        _b),
                    teamLevels: teamLevels,
                    teamUsersInScope: TEAM_USER_COUNT,
                    usersInScope: 1,
                    userCurrentLevel: currentLevel,
                    userPreviousLevel: previousLevel
                };
            })
        };
    }
    if (input.orgUnitId) {
        var users_1 = getUsers({
            userId: null,
            orgUnitId: input.orgUnitId
        }).slice(0, 8);
        var summaryCounts_2 = buildLevelCounts(1, 1);
        return {
            period: {
                isValid: true,
                weekCount: Math.max(1, getGeminiUsageLevelDistributionWeekPeriods(dateFrom, dateTo).length),
                effectiveDateFrom: dateFrom,
                effectiveDateTo: dateTo
            },
            usersInScope: users_1.length || usersInScope,
            view: GeminiGroupedChartViewEnum.USER,
            summary: GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
                acc[level] = {
                    count: summaryCounts_2[level],
                    share: level === GeminiUsageLevelEnum.MEDIUM ? 100 : 0,
                    previous: getPercentageDiff(1, summaryCounts_2[level])
                };
                return acc;
            }, {}),
            segments: (users_1.length
                ? users_1
                : [
                    { id: 101, name: 'Alex Johnson', email: 'alex@demo.com' },
                    { id: 102, name: 'Sam Lee', email: 'sam@demo.com' }
                ]).map(function (user, index) {
                var _a, _b;
                var _c;
                var currentLevel = LEVEL_CYCLE[index % LEVEL_CYCLE.length];
                var previousLevel = (_c = LEVEL_CYCLE[(index + 1) % LEVEL_CYCLE.length]) !== null && _c !== void 0 ? _c : GeminiUsageLevelEnum.ZERO;
                return {
                    id: String(user.id),
                    name: user.name || user.email,
                    currentLevels: (_a = {},
                        _a[GeminiUsageLevelEnum.ZERO] = currentLevel === GeminiUsageLevelEnum.ZERO ? 1 : 0,
                        _a[GeminiUsageLevelEnum.LOW] = currentLevel === GeminiUsageLevelEnum.LOW ? 1 : 0,
                        _a[GeminiUsageLevelEnum.MEDIUM] = currentLevel === GeminiUsageLevelEnum.MEDIUM ? 1 : 0,
                        _a[GeminiUsageLevelEnum.HIGH] = currentLevel === GeminiUsageLevelEnum.HIGH ? 1 : 0,
                        _a),
                    previousLevels: (_b = {},
                        _b[GeminiUsageLevelEnum.ZERO] = previousLevel === GeminiUsageLevelEnum.ZERO ? 1 : 0,
                        _b[GeminiUsageLevelEnum.LOW] = previousLevel === GeminiUsageLevelEnum.LOW ? 1 : 0,
                        _b[GeminiUsageLevelEnum.MEDIUM] = previousLevel === GeminiUsageLevelEnum.MEDIUM ? 1 : 0,
                        _b[GeminiUsageLevelEnum.HIGH] = previousLevel === GeminiUsageLevelEnum.HIGH ? 1 : 0,
                        _b),
                    usersInScope: 1
                };
            })
        };
    }
    var orgUnits = getOrgUnits({ orgUnitId: input.orgUnitId });
    var segmentOrgUnits = orgUnits.length
        ? orgUnits
        : [
            { id: 1, title: 'Marketing' },
            { id: 2, title: 'Sales' },
            { id: 3, title: 'Finance' },
            { id: 4, title: 'Engineering' }
        ];
    var summaryCounts = buildLevelCounts(usersInScope, 0);
    var previousSummaryCounts = buildLevelCounts(usersInScope, 2);
    return {
        period: {
            isValid: true,
            weekCount: Math.max(1, getGeminiUsageLevelDistributionWeekPeriods(dateFrom, dateTo).length),
            effectiveDateFrom: dateFrom,
            effectiveDateTo: dateTo
        },
        usersInScope: usersInScope,
        view: GeminiGroupedChartViewEnum.TEAM,
        summary: GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
            acc[level] = {
                count: summaryCounts[level],
                share: Math.round((summaryCounts[level] / usersInScope) * 100),
                previous: getPercentageDiff(previousSummaryCounts[level], summaryCounts[level])
            };
            return acc;
        }, {}),
        segments: segmentOrgUnits.map(function (orgUnit, index) {
            var segmentUsers = Math.max(8, Math.floor(usersInScope / segmentOrgUnits.length));
            var currentLevels = buildLevelCounts(segmentUsers, index);
            var previousLevels = buildLevelCounts(segmentUsers, index + 1);
            return {
                id: String(orgUnit.id),
                name: orgUnit.title,
                currentLevels: currentLevels,
                previousLevels: previousLevels,
                usersInScope: segmentUsers
            };
        })
    };
};
